module.exports = __webpack_public_path__ + "6-o2.gif?19ddcbd80884baeb200efa5648563f0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/6-o2.gif
// module id = 659
// module chunks = 0